import { ApartmentSets } from './apartment-sets.js';

/**
 * Get all the available apartments from all data sets
 */
const AllApartments = Object.values(ApartmentSets).flat();

export { AllApartments };
//# sourceMappingURL=all-apartments.js.map
